<template>
<div style="overflow: auto;">
  <el-menu
    unique-opened
    :collapse="iscollapse"
    :default-active="$route.path"
    :collapse-transition="false"
    class="el-menu-vertical-demo"
    router>
    <!-- <el-menu-item v-if="!showAdmin" index="/home/index">
      <i class="el-icon-s-home"></i>
      <span>整体数据概况</span>
    </el-menu-item> -->
    <el-menu-item index="/enterpriseManagement/index">
      <i class="el-icon-office-building"></i>
      <span>企业信息查询</span>
    </el-menu-item>
    <el-menu-item v-if="showAdmin" index="/departmentManagement/index">
      <i class="el-icon-copy-document"></i>
      <span>部门账号配置</span>
    </el-menu-item>
    <el-menu-item v-if="showAdmin" index="/townManagement/index">
      <i class="el-icon-menu"></i>
      <span>乡镇账号配置</span>
    </el-menu-item>
    <el-submenu v-if="showAdmin" index="1">
      <template slot="title">
        <i class="el-icon-setting"></i>
        <span>系统管理配置</span>
      </template>
      <el-menu-item index="/areaManagement/index">
        <i class="el-icon-s-grid"></i>
        <span>区域管理</span>
      </el-menu-item>
      <el-menu-item index="AccountManagement">
        <i class="el-icon-s-grid"></i>
        <span>账号管理</span>
      </el-menu-item>
    </el-submenu>
    <!-- <el-submenu v-if="showDepartment" index="1">
      <template slot="title">
        <i class="el-icon-news"></i>
        <span>相关部门信息</span>
      </template>
      <el-menu-item index="/department/departmentBase">
        <i class="el-icon-menu"></i>
        <span>基本信息调研</span>
      </el-menu-item>
      <el-menu-item index="/department/specialDepartment">
        <i class="el-icon-pie-chart"></i>
        <span>特定信息调研</span>
      </el-menu-item>
    </el-submenu> -->
    <template v-if="showDepartment">
      <el-menu-item :disabled="$store.getters.userInfo.id != 10773" index="/department/departmentBase">
        <i class="el-icon-menu"></i>
        <span>部门信息调研</span>
      </el-menu-item>
      <el-menu-item :disabled="$store.getters.userInfo.id != 10773" index="/department/specialDepartment">
        <i class="el-icon-pie-chart"></i>
        <span>特定信息调研</span>
      </el-menu-item>
    </template>
    <el-menu-item disabled v-if="showTown" index="/town/index">
      <i class="el-icon-collection"></i>
      <span>相关乡镇信息</span>
    </el-menu-item>
    <!-- <el-menu-item index="/systemData/index">
      <i class="el-icon-document"></i>
      <span>系统资料</span>
    </el-menu-item> -->
  </el-menu>
</div>
  
</template>

<script>
  export default {
    props: {
      iscollapse: Boolean
    },
    data () {
      return {
        userInfo: {},
        permissionMap: {}
      }
    },
    computed: {
      query () {
        return this.permissionMap['QueryVisited'] && this.permissionMap['NoQueryVisited'] && this.permissionMap['QuestionableRecords'] && this.permissionMap['RevenueAlert']
      },
      showAdmin () {
        let userInfo = this.$store.getters.userInfo
        if (userInfo.department_id === 0 && userInfo.town_id === 0) {
          return true
        } else {
          return false
        }
      },
      showDepartment () {
        let userInfo = this.$store.getters.userInfo
        if (userInfo.department_id === 0) {
          return false
        } else {
          return true
        }
      },
      showTown () {
        let userInfo = this.$store.getters.userInfo
        if (userInfo.town_id === 0) {
          return false
        } else {
          return true
        }
      }
    },
    mounted () {
      let userInfo = this.$store.getters.userInfo
      this.userInfo = userInfo
       // 权限表
      let permissionMap = {}
      let permissionList = JSON.parse(this.$store.state.permissionList)
      for (let i in permissionList) {
        permissionMap[permissionList[i]] = true
      }
      this.permissionMap = permissionMap
    }
  }
</script>

<style scoped>
  .el-scrollbar__wrap {
  overflow-x: hidden;
}
.item-left {
  padding-left:5px !important;
}
.item-left2 {
  padding-left:20px !important;
}
.el-submenu__title {
  padding: 0 !important;
}
.el-menu-item {
  /* padding: 0 !important; */
}
</style>


// WEBPACK FOOTER //
// src/components/frame/Sidebar.vue